export const testPatientData = {
  id: 'test-patient-id',
  username: 'Test Patient',
  videoUrl: '/v2/videos/test-patient.mp4',
  avatarUrl: '/v2/images/test-patient-avatar.jpeg',
  countryCode: 'US',
  countryName: 'United States',
  state: 'Colorado',
  testIp: '',
} as const;
